const STORAGE_VERSION = 1;

function restaurantScope() {
  return localStorage.getItem("restaurantId") || "default";
}

function progressKey() {
  return `onboardingTourProgress:${STORAGE_VERSION}:${restaurantScope()}`;
}

export function loadTourProgress() {
  try {
    const raw = localStorage.getItem(progressKey());
    if (!raw) return { visitedStepIds: [] };
    const parsed = JSON.parse(raw);
    return {
      visitedStepIds: Array.isArray(parsed?.visitedStepIds) ? parsed.visitedStepIds : [],
    };
  } catch {
    return { visitedStepIds: [] };
  }
}

export function markTourStepVisited(stepId) {
  if (!stepId) return;
  const progress = loadTourProgress();
  if (progress.visitedStepIds.includes(stepId)) return;
  progress.visitedStepIds.push(stepId);
  localStorage.setItem(progressKey(), JSON.stringify(progress));
}

export function markTourModuleVisited(module) {
  if (!module?.steps?.length) return;
  const progress = loadTourProgress();
  const ids = new Set(progress.visitedStepIds);
  module.steps.forEach((step) => ids.add(step.id));
  localStorage.setItem(progressKey(), JSON.stringify({ visitedStepIds: [...ids] }));
}

export function clearTourProgress() {
  localStorage.removeItem(progressKey());
}
